// A–F grade distribution mini-bar (fixed RAG tones, matching the GradeChip)
// shared by the loans-list summary strip and the portfolio dashboard.
// Ungraded terminal-state loans are excluded by the caller.

export const GRADE_BAR_CLASS: Record<string, string> = {
  A: "bg-status-success",
  B: "bg-status-success/60",
  C: "bg-status-warning",
  D: "bg-status-error/60",
  F: "bg-status-error",
};

export const GRADE_ORDER = ["A", "B", "C", "D", "F"] as const;

export function GradeDistributionBar({
  gradeCounts,
  testIdPrefix = "grade-distribution",
}: {
  gradeCounts: Record<string, number>;
  testIdPrefix?: string;
}) {
  const total = GRADE_ORDER.reduce((sum, g) => sum + (gradeCounts[g] ?? 0), 0);
  if (total === 0) {
    return <span className="text-small text-gray-mid">No graded loans</span>;
  }
  return (
    <div className="flex flex-col gap-space-1 min-w-[180px]">
      <div
        className="flex h-2 w-full overflow-hidden rounded-pill bg-white-warm"
        role="img"
        aria-label={`Grade distribution: ${GRADE_ORDER.map(
          (g) => `${g} ${gradeCounts[g] ?? 0}`,
        ).join(", ")}`}
      >
        {GRADE_ORDER.map((g) =>
          (gradeCounts[g] ?? 0) > 0 ? (
            <span
              key={g}
              className={GRADE_BAR_CLASS[g]}
              style={{ width: `${((gradeCounts[g] ?? 0) / total) * 100}%` }}
            />
          ) : null,
        )}
      </div>
      <div className="flex gap-space-2 text-caption text-gray-mid tabular-nums">
        {GRADE_ORDER.map((g) => (
          <span key={g} data-testid={`${testIdPrefix}-${g}`}>
            {g} {gradeCounts[g] ?? 0}
          </span>
        ))}
      </div>
    </div>
  );
}
